export const SCENARIO_KEYS = ['furniture', 'resort', 'homecare']

const KR_DEFAULTS = {
  apiOrigin: 'https://genai-api-ap2.svc.delight.ai',
  appId: '2A980229-8DF2-4E3F-B315-A63AD6385E68',
  agents: {
    furniture: 'e3119769-e3ed-41f3-badb-8342c7f16a0d',
    resort: 'cc037c43-ad81-4696-8492-c5d8efea5c53',
    homecare: '5209a670-da39-423a-9883-e61644830574'
  },
  prefix: 'kr'
}

const EN_DEFAULTS = {
  apiOrigin: 'https://genai-api-us3.svc.delight.ai',
  appId: '72F30A01-F727-4FDD-BF43-F7B5A7077307',
  agents: {
    furniture: '5ab6a396-1844-4422-8c33-373b046127b2',
    resort: '55d0f227-00a4-4d63-9086-be5b282f67bb',
    homecare: '95f2482e-fec6-4356-a570-0dcec6419de3'
  },
  prefix: 'en'
}

function isPageBuilderCanvas() {
  if (!import.meta.client) return false
  return new URLSearchParams(window.location.search).get('pb-builder') === '1'
}

export function getVoiceDemoConfig(locale = 'ko') {
  const runtime = useRuntimeConfig()
  const publicConfig = runtime.public || {}
  const isKorean = locale === 'ko'
  const defaults = isKorean ? KR_DEFAULTS : EN_DEFAULTS
  const prefix = defaults.prefix

  return {
    apiOrigin:
      (isKorean ? publicConfig.voiceDemoApiOrigin : publicConfig.voiceDemoApiOriginEn)
      || defaults.apiOrigin,
    appId: (isKorean ? publicConfig.voiceDemoAppId : publicConfig.voiceDemoAppIdEn) || defaults.appId,
    agents: {
      furniture:
        (isKorean ? publicConfig.voiceDemoAgentFurniture : publicConfig.voiceDemoAgentFurnitureEn)
        || defaults.agents.furniture,
      resort:
        (isKorean ? publicConfig.voiceDemoAgentResort : publicConfig.voiceDemoAgentResortEn)
        || defaults.agents.resort,
      homecare:
        (isKorean ? publicConfig.voiceDemoAgentHomecare : publicConfig.voiceDemoAgentHomecareEn)
        || defaults.agents.homecare
    },
    storagePrefix: `${prefix}-demo`,
    authTokenKey: `${prefix}-demo-auth-token`,
    authAgentKey: `${prefix}-demo-auth-agent-id`,
    userIdKey: `${prefix}-demo-user-id`,
    livekitWsKey: `${prefix}-livekit-ws-url`,
    loginVariant: 'demo_login',
    pbBuilder: isPageBuilderCanvas()
  }
}

export const MIC_OPTIONS = {
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: false,
  channelCount: 1,
  // 16 kHz is what the working KR demo publishes; `ideal` lets the browser
  // fall back rather than failing getUserMedia.
  sampleRate: { ideal: 16000 }
}

// Safari rejects or silently empties tracks when sampleRate / channelCount
// are constrained. Keep AEC+NS+AGC-off only.
export const MIC_OPTIONS_IOS = {
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: false,
  // Plain string — LiveKit structuredClone()s these options. A missing
  // deviceId is filled from Room.audioCaptureDefaults, which must not be
  // a Vue Proxy (DataCloneError on iOS).
  deviceId: 'default'
}

export const MIC_GAIN = 3

// Shared across locales so a call on /voice ends a call on /ko/voice in
// another tab (and the reverse).
export const CALL_CHANNEL = 'kr-voice-demo-call'

export const DEMO_USER_ID = 'tester-user-172d1ee190f13b1b68d97c72278bb17f'

// Kept so existing imports that only need the KR keys still resolve.
export const LIVEKIT_WS_KEY = 'kr-livekit-ws-url'
export const AUTH_TOKEN_KEY = 'kr-demo-auth-token'
export const AUTH_AGENT_KEY = 'kr-demo-auth-agent-id'
export const USER_ID_KEY = 'kr-demo-user-id'

export const CONNECT_WATCHDOG_MS = 30_000
export const SLOW_CONNECT_MS = 8_000
export const MAX_CALL_MS = 10 * 60_000
export const HIDDEN_GRACE_MS = 30_000
export const RATE_LIMIT_COOLDOWN_MS = 10_000
export const ENDED_BADGE_MS = 1_450
